
import mapGetActions from './map';

export * from './map';

export function getActions(dispatch) {
    return {
        ...mapGetActions(dispatch)
    }
}
